import { ENTITY } from '../constant';
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { SOFTWARE } from '../constant/actionTypes';

const apiEndPoint = constants.ADMIN_URL;

export const doSoftwareSettingsCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.SOFTWARE_SETTINGS}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doSoftwareSettingsDelete = (Id) => {
  const endPointUri = constants.API.SOFTWARE_SETTINGS_BY_ID.replace(ENTITY.SOFTWARE_SETTINGS_ID, Id);
  return httpservice()
    .delete(endPointUri)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const doSoftwareSettingsUpdate = (Id, data) => {
  const endPointUri = constants.API.SOFTWARE_SETTINGS_BY_ID.replace(ENTITY.SOFTWARE_SETTINGS_ID, Id);
  return httpservice()
    .put(endPointUri, data)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

export const getSoftwareSetting = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: SOFTWARE.SOFTWARE_SETTINGS.INITIATE,
  });
  return httpservice()
    .get(constants.API.SOFTWARE_SETTINGS_BY_ID.replace(ENTITY.SOFTWARE_SETTINGS_ID, id))
    .then((response) => {
      dispatch({
        payload: { data: response.data.response },
        type: SOFTWARE.SOFTWARE_SETTINGS.SUCCESS,
      });
      return response.data;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.SOFTWARE_SETTINGS.SUCCESS,
      });
      return error && error.response && error.response.data ? error.response.data : error;
    });
};

export const getAllSoftwareSetting = (id, dispatch) => {
  dispatch({
    payload: [],
    type: SOFTWARE.SOFTWARE_SETTINGS.INITIATE,
  });
  return httpservice()
    .get(constants.API.SOFTWARE_SETTINGS)
    .then((response) => {
      dispatch({
        payload: { data: response.data, count: response.data.count },
        type: SOFTWARE.SOFTWARE_SETTINGS.SUCCESS,
      });
      return response.data;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.SOFTWARE_SETTINGS.SUCCESS,
      });
      return error.response.data;
    });
};
